// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53071ad1","453":"f769d5c9","455":"4e127fc3","977":"b492ad24"}[chunkId] + ".chunk.js";
};